import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CodeBookImportStatusSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type CodeBookImportStatusSubscription = { __typename?: 'subscription_root', code_book_imports_by_pk?: { __typename?: 'code_book_imports', id: any, status: string, error_message?: string | null, page_count?: number | null, section_count?: number | null, printed_as_provision?: number | null, not_captured?: number | null, missing_parents?: number | null, figure_count?: number | null, commentary_family?: string | null } | null };


export const CodeBookImportStatusDocument = gql`
    subscription codeBookImportStatus($id: uuid!) {
  code_book_imports_by_pk(id: $id) {
    id
    status
    error_message
    page_count
    section_count
    printed_as_provision
    not_captured
    missing_parents
    figure_count
    commentary_family
  }
}
    `;

/**
 * __useCodeBookImportStatusSubscription__
 *
 * To run a query within a React component, call `useCodeBookImportStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCodeBookImportStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCodeBookImportStatusSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCodeBookImportStatusSubscription(baseOptions: Apollo.SubscriptionHookOptions<CodeBookImportStatusSubscription, CodeBookImportStatusSubscriptionVariables> & ({ variables: CodeBookImportStatusSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CodeBookImportStatusSubscription, CodeBookImportStatusSubscriptionVariables>(CodeBookImportStatusDocument, options);
      }
export type CodeBookImportStatusSubscriptionHookResult = ReturnType<typeof useCodeBookImportStatusSubscription>;
export type CodeBookImportStatusSubscriptionResult = Apollo.SubscriptionResult<CodeBookImportStatusSubscription>;